import { SELECT_STYLE, CHANGE_AUTH, WAY, SAVE_QUERY } from './actions';

const initialState = {
  selectStyle: '1', // tab 1 可退改 2 处理中 3 已退改
  ticketType: '', // 请求参数 0-代表处理中  1-代表已退改
  authenticated: 0, // -1未实名认证且不展示 0未实名认证 1实名认证
  urlQuery: {}, // 存储首次进入时所带的参数
  // faceCheckSwitch: false,
  // faceCheckChannel: false,
};

export default function cancelLationReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_STYLE:
      return Object.assign({}, state, {
        selectStyle: action.data,
        ticketType: action.data === '2' ? '1' : '',
      });
    case CHANGE_AUTH:
      return Object.assign({}, state, {
        authenticated: action.data,
      });
    case WAY:
      return Object.assign({}, state, {
        way: action.data,
      });
    case SAVE_QUERY:
      const params = Object.assign({}, state.urlQuery, action.data);
      return Object.assign({}, state, {
        urlQuery: params,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes/cancelLation/modules/cancelLation.js